(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"), require("FEGOWebapi"), require("FEGORender"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi", "FEGOWebapi", "FEGORender"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/basic-swiper/render"] = factory(require("VueDemi"), require("FEGOWebapi"), require("FEGORender"));
	else
		root["/fego/component/basic-swiper/render"] = factory(root["VueDemi"], root["FEGOWebapi"], root["FEGORender"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__2309__, __WEBPACK_EXTERNAL_MODULE__5113__, __WEBPACK_EXTERNAL_MODULE__5322__) => {
return 